import { Loader } from '@googlemaps/js-api-loader';
import { Validator } from "../../snippets/Validator";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { FormActions } from "../abstracts/mixins/FormActions";
import moment from 'moment-timezone';

export const Employee = (() => {

    return class Employee extends CRUDEntity {

        static #LOCATIONS_TYPE={
            UPDATE_LOCATION:1,
            UPDATE_JOB_STATUS:2,
            START_SEND_LOCATION:3,
            END_SEND_LOCATION:4
        }

        static get LOCATIONS_TYPE(){
            return this.#LOCATIONS_TYPE
        }

        #validation_fields = [
            'email',
            'first_name',
            'last_name',
            'address',
            'position',
        ]

        map = null
        mapObjs = []

        constructor(id = null) {
            super();
            this.entityClass = 'employee';
            this.urlRoot = '/employees/employee';
            this.sectionRootUrl = '/employees';
            this.id = id;

            Object.assign(Employee.prototype, FormActions);
            Object.assign(Employee.prototype, EntityModalForm);
            Object.assign(Employee.prototype, HasAttachments);

            this.setAttachmentCallbackDelete()
            Employee.prototype.delegatedListnersForButtons = function (type, entityClass) {
                const checkFields = () => {
                    if (this.validationForm(type))
                        $(`#${type}-${entityClass} button#${type}`).attr('disabled', false)
                    else
                        $(`#${type}-${entityClass} button#${type}`).attr('disabled', true)
                }
                for (let field of this.#validation_fields) {
                    $(`#${type}-${entityClass} input[name=${field}]`).on({
                        input: checkFields,
                        change: checkFields
                    })
                }

                $(`#${type}-${entityClass} button#edit`).off();
                $(`#${type}-${entityClass} button#edit`).on('click', () => {
                    if (this.validationForm(type, true)) {
                        if (type == 'edit') {
                            this.update(this.updateCallback);
                        }
                    }
                });
            }
        }

        validationForm(type, isSelectErrorFields = false) {
            const formId = 'edit-employee';
            const data = this.collectDataInForm(formId);
            const validator = new Validator({
                'email': ['required'],
                'first_name': ['required'],
                'last_name': ['required'],
                'address': ['required'],
                // 'position': ['required'],
            });
            let validate_flag = true;

            this.#validation_fields.forEach(element => {
                if (validator.validate(element, data[element])) {
                    if (isSelectErrorFields)
                        $('#' + formId + ' [name="' + element + '"]').removeClass('border-danger').css('border', '');
                } else {
                    validate_flag = false;
                    if (isSelectErrorFields)
                        $('#' + formId + ' [name="' + element + '"]').addClass('border-danger').css('border', '2px solid');
                }
            });

            return validate_flag;
        }

        changeEmployeeStatus(id,status) {
            $.ajax({
                method: 'GET',
                data:{status:status},
                url: `/employees/employee/${id}/status`,
                success: (response) => {
                    $('#employee_confirmation').html(response.modal)
                    $('#confirm-action-modal').modal('show')

                }
            });
        }
        deleteEmployee(id){
            $.ajax({
                method: 'POST',
                url: `/employees/employee/${id}/delete`,
                success: (response) => {
                    $('#employee_confirmation').html(response.modal)
                    $('#confirm-action-modal').modal('show')
                }
            });
        }
        updateCallback(){
            setTimeout(() => window.location.reload(), 300);
        }

        updateLocations(id,date){
            const _this = this
            $.ajax({
                method: 'GET',
                url: `/employees/employee/${id}/show-jobs-map`,
                data: {
                    is_update:true,
                    date: date.format('YYYY-MM-DD')
                },
                success: (response) => {
                    $('#locations-table').html(response.content)
                    $('#jobs-map-modal .view-map-pin').on('click', (ev)=>{
                        $('#jobs-map-modal #panel-map').removeClass('d-none')
                        $('#jobs-map-modal #panel-list').addClass('d-none')
                        let lat = Number($(ev.currentTarget).data('lat'))
                        let lon = Number($(ev.currentTarget).data('lon'))
                        if(_this.map != null){
                            _this.map.setCenter(new google.maps.LatLng(lat, lon))
                        }
                    })
                    $('#gap-time').text(response.gapTime);
                    $('#start-to-final-time').text(response.startToFinalTime);
                    $('#total-activity-time').text(response.totalActivityTime);
                    (_this.clearMap.bind(_this))();
                    (_this.routeDisplayMap.bind(_this))(response.locations);
                }
            })
        }

        clearMap() {
            this.mapObjs.forEach(obj => obj.setMap(null));  
            this.mapObjs = []  
        }
        
        showJobsMap(id){
            const _this = this
            $.ajax({
                method: 'GET',
                data: {
                    date: moment().tz('America/New_York').format('YYYY-MM-DD')
                },
                url: `/employees/employee/${id}/show-jobs-map`,
                success: (response) => {
                    $('#employee_confirmation').html(response.modal)
                    $('#jobs-map-modal').modal('show')
                    $('#jobs-map-modal').on('hide.bs.modal', ()=>{
                        _this.map=null
                        _this.mapObjs = []
                    })
                    $('#jobs-map-modal #toggle-btn').on('click', (ev)=>{
                        let type = $(ev.currentTarget).data('type')
                        $('#jobs-map-modal .jobs-panel').each(function(){
                            if(this.id == `panel-${type}`)
                                $(this).removeClass('d-none')
                            else
                                $(this).addClass('d-none')
                        })
                        switch(type){
                            case 'map': 
                                $('#toggle-btn #toggle-btn-text').text('View List')
                                $('#toggle-btn').data('type','list')
                                $('#times').addClass('d-none').removeClass('d-flex')
                                $('#jobs-map-modal .modal-title').text('Work Progress Tracker (Map)')
                                break
                            case 'list': 
                                $('#times').removeClass('d-none').addClass('d-flex')
                                $('#jobs-map-modal .modal-title').text('Work Progress Tracker (List)') 
                                $('#toggle-btn #toggle-btn-text').text('View Map')
                                $('#toggle-btn').data('type','map')
                                break
                        }
                    })

                    $('.location-date-picker').daterangepicker({
                        autoApply:true,
	                    singleDatePicker : true,
                        startDate: Date.now(),
                        format: 'MM/DD/YYYY',
                    });
                    
                    $('.location-date-picker').on('apply.daterangepicker', (ev, picker) => {
                        (_this.updateLocations.bind(_this))(id, picker.startDate)
                    });

                    $('#jobs-map-modal .view-map-pin').on('click', (ev)=>{
                        $('#jobs-map-modal #panel-map').removeClass('d-none')
                        $('#jobs-map-modal #panel-list').addClass('d-none')
                        $('#toggle-btn #toggle-btn-text').text('View List')
                        $('#toggle-btn').data('type','list')
                        $('#times').addClass('d-none').removeClass('d-flex')
                        let lat = Number($(ev.currentTarget).data('lat'))
                        let lon = Number($(ev.currentTarget).data('lon'))
                        if(_this.map != null){
                            _this.map.setCenter(new google.maps.LatLng(lat, lon))
                        }
                    })

                    if($('meta[name="google-api-key"]').length){
                        let googlApi = $('meta[name="google-api-key"]').attr('content');
                        const apiOptions = {
                            apiKey: googlApi
                        };
                        const loader = new Loader(apiOptions);
                        loader.load().then(() => {
                            (_this.routeDisplayMap.bind(_this))(response.locations)
                        });
                    }
                    
                }
            })
        }

        async routeDisplayMap(locations) {
            if(!locations.length){
                $('#no-coord-data').removeClass('d-none')
                return
            }else{
                $('#no-coord-data').addClass('d-none')
            }
                
            if(!this.map){
                let route_map_center = new google.maps.LatLng(locations[0].location.lat, locations[0].location.lon);
                let mapCanvas = document.getElementById('map-container');
                let mapOptions = {
                    zoom: 15,
                    center: route_map_center,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapId: "DEMO_MAP_ID",
                    disableDefaultUI: false,
                    scrollwheel: false,
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    clickableIcons: false,
                    styles: [{"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"}]},
                        {"featureType": "poi", "stylers": [{"visibility": "off"}]},
                        {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                        {"featureType": "transit", "stylers": [{"visibility": "off"}]}]
                };
                let map = new google.maps.Map(mapCanvas, mapOptions);
                this.map = map
            }
            
           
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
           
            let poly=null,path=null, color=null
 
            for(let location of locations){
                color = color==null ? `rgb(${this.getRandomInt(40,120)}, ${this.getRandomInt(40,120)}, ${this.getRandomInt(40,120)})` : color
                if(location.type == Employee.LOCATIONS_TYPE.START_SEND_LOCATION){
                    color = `rgb(${this.getRandomInt(40,120)}, ${this.getRandomInt(40,120)}, ${this.getRandomInt(40,120)})`
                    poly = new google.maps.Polyline({ strokeColor: color, strokeOpacity: 1.0, strokeWeight: 3 });
                    this.mapObjs.push(poly)
                    poly.setMap(this.map)
                    path = poly.getPath();
                }
                if(path)
                    path.push(new google.maps.LatLng(location.location.lat, location.location.lon))
                const customTag = document.createElement('div');
                customTag.className = 'custom-tag';
                customTag.style.backgroundColor = color;
                customTag.innerHTML = `${moment(location.time).tz('America/New_York').format('LT')}<div class="arrow" style="border-top-color:${color}"></div>`
                let marker = new AdvancedMarkerElement({
                    position: {
                        lat: parseFloat(location.location.lat),
                        lng: parseFloat(location.location.lon),
                    },
                    content: customTag,
                    map: this.map,
                });
                this.mapObjs.push(marker)
                if(location.type == Employee.LOCATIONS_TYPE.END_SEND_LOCATION){
                    poly = null
                    path = null
                }
            }
        }

        getRandomInt(min, max) {
            const minCeiled = Math.ceil(min);
            const maxFloored = Math.floor(max);
            return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
        }
    
    }

})();
